import './compare-tab.scss';
